<template>
<div class="champion-wrap">
    <h2 class="champion-label">モトクロス全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('60')"><span class="history__head--circle">1964-1970</span></button>
        <div class="champions">
          <section class="champions__sec">
            <h2 class="year-title">1964年<span class="year-title__sub">昭和41年</span></h2>
            <ul>
              <li>小島松久／第1回日本GP50cc</li>
              <li>久保和夫／第1回日本GP125cc</li>
              <li><p>久保和夫／第1回日本GP250cc</p>                                        </li>
              <li>三室恵義／第1回日本GP251cc以上</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1965年<span class="year-title__sub">昭和40年</span></h2>
            <ul>
              <li>菅家安智／第2回日本GP90cc(J)</li>
              <li>荒井市次／第2回日本GP125cc（120J)</li>
              <li>荒井市次／第2回日本GP250cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1966年<span class="year-title__sub">昭和41年</span></h2>
            <ul>
              <li>小島松久／第3回日本GP90cc(J)</li>
              <li>荒井市次／第3回日本GP125cc</li>
              <li>小島松久／第3回日本GP250cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1967年<span class="year-title__sub">昭和42年</span></h2>
            <ul>
                <li>黒川 隆／アマチュア50cc</li>
                <li>河野和憲／アマチュア90cc(J)</li>
                <li>高橋道雄／アマチュア125cc</li>
                <li>高橋道雄／アマチュア250cc</li>
                <li>森下 博／アマチュア251cc以上</li>
                <li>山本 隆／ジュニア90cc(J)</li>
                <li>吉村太一／ジュニア125cc</li>
                <li>山本 隆／ジュニア250cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1968年<span class="year-title__sub">昭和43年</span></h2>
            <ul>
                <li>堀 勇／アマチュア50cc</li>
                <li>堀 勇／アマチュア90cc(J)</li>
                <li>堀 勇／アマチュア125cc</li>
                <li>山下和男／アマチュア250cc</li>
                <li>山下和男／アマチュア251cc以上</li>
                <li>蛯名博昭／ジュニア50cc</li>
                <li>蛯名博昭／ジュニア90cc(J)</li>
                <li>西 信之／ジュニア125cc</li>
                <li>西 信之／ジュニア250cc</li>
                <li>ロバート・E.エーモ／ジュニア251cc以上</li>
                <li>星野一義／セニア90cc(J)</li>
                <li>星野一義／セニア125cc</li>
                <li>山本 隆／セニア250cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1969年<span class="year-title__sub">昭和44年</span></h2>
            <ul>
                <li>田中敏男／アマチュア50cc</li>
                <li>多田茂次／アマチュア90cc(J)</li>
                <li>中里道夫／アマチュア125cc</li>
                <li>岩尾一敏／アマチュア250cc</li>
                <li>堀 勇／ジュニア50cc</li>
                <li>従野孝司／ジュニア90cc(J)</li>
                <li>鈴木秀明／ジュニア125cc</li>
                <li>鈴木秀明／ジュニア250cc</li>
                <li>山本 隆／セニア90cc(J)</li>
                <li>矢島金次郎／セニア125cc</li>
                <li>鈴木忠男／セニア250cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1970年<span class="year-title__sub">昭和45年</span></h2>
            <ul>
                <li>一色 薫／ノービス50cc</li>
                <li>小田切信雄／ノービス90cc(J)</li>
                <li>平野芳男／ノービス125cc</li>
                <li>青木雅和／ノービス250cc</li>
                <li>鈴木都良夫／ジュニア90cc(J)</li>
                <li>岩尾一敏／ジュニア125cc</li>
                <li>岩尾一敏／ジュニア250cc</li>
                <li>吉村太一／セニア125cc</li>
                <li>吉村太一／セニア250cc</li>
            </ul>
          </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('70')"><span class="history__head--circle">1971-1980</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1971年<span class="year-title__sub">昭和46年</span></h2>
                <ul>
                  <li>栗原和年／ノービス90cc(J)</li>
                  <li>栗原和年／ノービス125cc</li>
                  <li>斉藤英夫／ノービス250cc</li>
                  <li>中村 忠／ジュニア90cc(J)</li>
                  <li>杉浦種保／ジュニア125cc</li>
                  <li>竹沢正治／ジュニア250cc</li>
                  <li>瀬尾勝彦／エキスパートジュニア125cc</li>
                  <li>瀬尾勝彦／エキスパートジュニア250cc</li>
                  <li>矢島金次郎／セニア125cc</li>
                  <li>上野広一／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1972年<span class="year-title__sub">昭和47年</span></h2>
                <ul>
                  <li>藤 秀信／ノービス90cc(J)</li>
                  <li>藤 秀信／ノービス125cc</li>
                  <li>藤 秀信／ノービス250cc</li>
                  <li>唐沢栄三郎／ジュニア90cc(J)</li>
                  <li>唐沢栄三郎／ジュニア125cc</li>
                  <li>唐沢栄三郎／ジュニア250cc</li>
                  <li>小田切信雄／エキスパートジュニア125cc</li>
                  <li>池田 勝／エキスパートジュニア250cc</li>
                  <li>鈴木秀明／セニア125cc</li>
                  <li>鈴木都良夫／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1973年<span class="year-title__sub">昭和48年</span></h2>
                <ul>
                  <li>菅家 恵／ノービス90cc(J)</li>
                  <li>村上光則／ノービス125cc</li>
                  <li>菅家 恵／ノービス250cc</li>
                  <li>吉田哲郎／ジュニア90cc(J)</li>
                  <li>吉田哲郎／ジュニア125cc</li>
                  <li>吉田哲郎／ジュニア250cc</li>
                  <li>岸川清秀／エキスパートジュニア125cc</li>
                  <li>藤 秀信／エキスパートジュニア250cc</li>
                  <li>鈴木都良夫／セニア125cc</li>
                  <li>鈴木秀明／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1974年<span class="year-title__sub">昭和49年</span></h2>
                <ul>
                    <li>谷川徹二／ジュニア90cc(J)</li>
                  <li>光安鉄美／ジュニア125cc</li>
                  <li>大賀広美／ジュニア250cc</li>
                  <li>渡辺 明／エキスパートジュニア125cc</li>
                  <li>渡辺 明／エキスパートジュニア250cc</li>
                  <li>鈴木秀明／セニア125cc</li>
                  <li>鈴木秀明／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1975年<span class="year-title__sub">昭和50年</span></h2>
                <ul>
                    <li>北村隆資／ジュニア90cc(J)</li>
                    <li>青山金助／ジュニア125cc</li>
                    <li>青山金助／ジュニア250cc</li>
                    <li>東福寺保雄／エキスパートジュニア125cc</li>
                    <li>東福寺保雄／エキスパートジュニア250cc</li>
                    <li>杉尾良文／セニア125cc</li>
                    <li>増田耕二／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1976年<span class="year-title__sub">昭和51年</span></h2>
                <ul>
                    <li>月岡尚人／ジュニア90cc(J)</li>
                    <li>月岡尚人／ジュニア125cc</li>
                    <li>横山隆夫／ジュニア250cc</li>
                    <li>光安鉄美／エキスパートジュニア125cc</li>
                    <li>青山金助／エキスパートジュニア250cc</li>
                    <li>鈴木都良夫／セニア125cc</li>
                    <li>竹沢正治／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1977年<span class="year-title__sub">昭和52年</span></h2>
                <ul>
                    <li>渡辺義己／ジュニア90cc(J)</li>
                    <li>小沢 孝／ジュニア125cc</li>
                    <li>福田正敏／ジュニア250cc</li>
                    <li>佐藤健二／エキスパートジュニア125cc</li>
                    <li>大泉浩一／エキスパートジュニア250cc</li>
                    <li>瀬尾勝彦／セニア125cc</li>
                    <li>瀬尾勝彦／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1978年<span class="year-title__sub">昭和53年</span></h2>
                <ul>
                  <li>原本松市／ジュニア90cc(J)</li>
                  <li>庄司 覚／ジュニア125cc</li>
                  <li>ジェイソン・ドレイコット／ジュニア250cc</li>
                  <li>佐々木隆／エキスパートジュニア125cc</li>
                  <li>佐々木隆／エキスパートジュニア250cc</li>
                  <li>瀬尾勝彦／セニア125cc</li>
                  <li>光安鉄美／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1979年<span class="year-title__sub">昭和54年</span></h2>
                <ul>
                  <li>斉藤武男／ジュニア90cc(J)</li>
                  <li>大久保和親／ジュニア125cc</li>
                  <li>堀口雅史／ジュニア250cc</li>
                  <li>秋元春夫／エキスパートジュニア125cc</li>
                  <li>原口 衛／エキスパートジュニア250cc</li>
                  <li>光安鉄美／セニア125cc</li>
                  <li>光安鉄美／セニア250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1980年<span class="year-title__sub">昭和55年</span></h2>
                <ul>
                  <li>小野沢良一／ジュニア125cc</li>
                  <li>小野沢良一／ジュニア250cc</li>
                  <li>谷川龍太郎／国際B級125cc</li>
                  <li>庄司 覚／国際B級250cc</li>
                  <li>東福寺保雄／国際A級125cc</li>
                  <li>杉尾良文／国際A級250cc</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('80')"><span class="history__head--circle">1981-1990</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1981年<span class="year-title__sub">昭和56年</span></h2>
                <ul>
                    <li>平山勝一／ジュニア125cc</li>
                    <li>茶谷 学／ジュニア250cc</li>
                    <li>岡部篤史／国際B級125cc</li>
                    <li>岡部篤史／国際B級250cc</li>
                    <li>東福寺保雄／国際A級125cc</li>
                    <li>福本敏夫／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1982年<span class="year-title__sub">昭和57年</span></h2>
                <ul>
                    <li>ロン・キンダー／ジュニア125cc</li>
                    <li>馬場善人／ジュニア250cc</li>
                    <li>小橋勝年／国際B級125cc</li>
                    <li>小橋勝年／国際B級250cc</li>
                    <li>大関昌典／国際A級125cc</li>
                    <li>東福寺保雄／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1983年<span class="year-title__sub">昭和58年</span></h2>
                <ul>
                    <li>天田 淳／ジュニア125cc</li>
                    <li>天田 淳／ジュニア250cc</li>
                    <li>茶谷 学／国際B級125cc</li>
                    <li>茶谷 学／国際B級250cc</li>
                    <li>庄司 覚／国際A級125cc</li>
                    <li>杉尾良文／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1984年<span class="year-title__sub">昭和59年</span></h2>
                <ul>
                    <li>調所伸一／ジュニア125cc</li>
                    <li>小栗伸幸／ジュニア250cc</li>
                    <li>菅原義広／国際B級125cc</li>
                    <li>鶴田 忍／国際B級250cc</li>
                    <li>東福寺保雄／国際A級125cc</li>
                    <li>スティーブ・マーチン／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1985年<span class="year-title__sub">昭和60年</span></h2>
                <ul>
                    <li>長沼朝之／ジュニア125cc</li>
                    <li>花田茂樹／ジュニア250cc</li>
                    <li>田渕 武／国際B級125cc</li>
                    <li>河崎智之／国際B級250cc</li>
                    <li>岡部篤史／国際A級125cc</li>
                    <li>スティーブ・マーチン／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1986年<span class="year-title__sub">昭和61年</span></h2>
                <ul>
                    <li>藤本正勝／ジュニア125cc</li>
                    <li>吉田和泉／ジュニア250cc</li>
                    <li>花田茂樹／国際B級125cc</li>
                    <li>花田茂樹／国際B級250cc</li>
                    <li>伊田井佐夫／国際A級125cc</li>
                    <li>東福寺保雄／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1987年<span class="year-title__sub">昭和62年</span></h2>
                <ul>
                    <li>岸田隆夫／ジュニア125cc</li>
                    <li>橋本信二／ジュニア250cc</li>
                    <li>吉田和泉／国際B級125cc</li>
                    <li>石橋博也／国際B級250cc</li>
                    <li>岡部篤史／国際A級125cc</li>
                    <li>東福寺保雄／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1988年<span class="year-title__sub">昭和63年</span></h2>
                <ul>
                    <li>大塚元和／ジュニア125cc</li>
                    <li>大塚元和／ジュニア250cc</li>
                    <li>大塚忠和／国際B級125cc</li>
                    <li>大塚忠和／国際B級250cc</li>
                    <li>岡部篤史／国際A級125cc</li>
                    <li>東福寺保雄／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1989年<span class="year-title__sub">昭和64年/平成元年</span></h2>
                <ul>
                    <li>黒古尚利／ジュニア125cc</li>
                    <li>黒古尚利／ジュニア250cc</li>
                    <li>芹沢太麻樹／国際B級125cc</li>
                    <li>榎本正則／国際B級250cc</li>
                    <li>光安鉄美／国際A級125cc</li>
                    <li>岡部篤史／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1990年<span class="year-title__sub">平成2年</span></h2>
                <ul>
                    <li>荻島忠雄／国内A級125cc</li>
                    <li>荻島忠雄／国内A級250cc</li>
                    <li>元木龍幸／国際B級125cc</li>
                    <li>村橋健太郎／国際B級250cc</li>
                    <li>東福寺保雄／国際A級125cc</li>
                    <li>東福寺保雄／国際A級250cc</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1991-2000</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1991年<span class="year-title__sub">平成3年</span></h2>
                <ul>
                    <li>半場謙吾／国際B級125cc</li>
                    <li>城田賢一／国際B級250cc</li>
                    <li>荻島忠雄／国際A級125cc</li>
                    <li>宮内隆行／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1992年<span class="year-title__sub">平成4年</span></h2>
                <ul>
                    <li>佐々木裕介／国際B級125cc</li>
                    <li>田沢豊晃／国際B級250cc</li>
                    <li>請川意次／国際A級125cc</li>
                    <li>エディ・ウォーレン／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>益留信太郎／国際B級125cc</li>
                    <li>益留信太郎／国際B級250cc</li>
                    <li>佐々木裕介／国際A級125cc</li>
                    <li>ロン・ティチナー／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>倉林啓一郎／国際B級125cc</li>
                    <li>成田 亮／国際B級250cc</li>
                    <li>小田切一剛／国際A級125cc</li>
                    <li>ロン・ティチナー／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>矢島健一／国際B級125cc</li>
                    <li>溝口哲也／国際B級250cc</li>
                    <li>川島雄一郎／国際A級125cc</li>
                    <li>ジェフ・マタセビッチ／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>井上眞一／国際B級125cc</li>
                    <li>井上眞一／国際B級250cc</li>
                    <li>川島雄一郎／国際A級125cc</li>
                    <li>ジェフ・マタセビッチ／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>増田一将／国際B級125cc</li>
                    <li>増田一将／国際B級250cc</li>
                    <li>高見俊次／国際A級125cc</li>
                    <li>ジェフ・マタセビッチ／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>平塚雅樹／国際B級125cc</li>
                    <li>平塚雅樹／国際B級250cc</li>
                    <li>増田一将／国際A級125cc</li>
                    <li>カイル・ルイス／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1999年<span class="year-title__sub">平成11年</span></h2>
                <ul>
                    <li>鈴木健介／国際B級125cc</li>
                    <li>戸倉徹哉／国際B級250cc</li>
                    <li>勝谷武史／国際A級125cc</li>
                    <li>カイル・ルイス／国際A級250cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2000年<span class="year-title__sub">平成12年</span></h2>
                <ul>
                    <li>藤田 卓／国際B級125cc</li>
                    <li>小泉貴文／国際B級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>佐合 潔／国際A級125cc</li>
                    <li>高濱龍一郎／国際A級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2010</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>釘村 忠／国際B級125cc</li>
                    <li>折原 徹／国際B級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>田島久誌／国際A級125cc</li>
                    <li>熱田孝高／国際A級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>小島庸平／国際B級125cc</li>
                    <li>村岡康裕／国際B級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>加賀真一／国際A級125cc</li>
                    <li>成田 亮／国際A級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>上田隼人／国際B級125cc</li>
                    <li>上田隼人／国際B級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>溝口哲也／国際A級125cc</li>
                    <li>成田 亮／国際A級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>内山慎太郎／国際B級125cc</li>
                    <li>伊藤正憲／国際B級IBOPEN</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>中村友則／国際A級125cc</li>
                    <li>成田 亮／国際A級250cc</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>斉木達也／国際B級ＩＢ２</li>
                    <li>片倉久斗／国際B級IBOPEN</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>福留善秀／国際A級ＩＡ２</li>
                    <li>小池田猛／国際A級IA1</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>富田俊樹／国際B級ＩＢ２</li>
                    <li>岡田 涼／国際B級IBOPEN</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>小島庸平／国際A級ＩＡ２</li>
                    <li>熱田孝高／国際A級IA1</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>稲垣佳樹／国際B級ＩＢ２</li>
                    <li>木下 隼／国際B級IBOPEN</li>
                    <li>鈴木沙耶／レディース</li>
                    <li>新井宏彰／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                    <li>鈴木沙耶／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>松下幸司／国際B級ＩＢ２</li>
                    <li>小関元貴／国際B級IBOPEN</li>
                    <li>益 春菜／レディース</li>
                    <li>勝谷武史／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                    <li>益 春菜／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>山本 鯨／国際B級ＩＢ２</li>
                    <li>山本 鯨／国際B級IBOPEN</li>
                    <li>益 春菜／レディース</li>
                    <li>勝谷武史／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                    <li>益 春菜／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>竹中純矢／国際B級ＩＢ２</li>
                    <li>竹中純矢／国際B級IBOPEN</li>
                    <li>益 春菜／レディース</li>
                    <li>小島太久摩／国際A級ＩＡ２</li>
                    <li>熱田孝高／国際A級IA1</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2020</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>近藤涼太／国際B級ＩＢ２</li>
                    <li>近藤涼太／国際B級IBOPEN</li>
                    <li>益 春菜／レディース</li>
                    <li>三原拓也／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>佐々木雅哉／国際B級ＩＢ２</li>
                    <li>能塚智寛／国際B級IBOPEN</li>
                    <li>邵 洋子／レディース</li>
                    <li>山本 鯨／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>大塚豪太／国際B級ＩＢ２</li>
                    <li>大塚豪太／国際B級IBOPEN</li>
                    <li>邵 洋子／レディース</li>
                    <li>富田俊樹／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>馬場亮太／国際B級ＩＢ２</li>
                    <li>古賀太基／国際B級IBOPEN</li>
                    <li>竹内優菜／レディース</li>
                    <li>勝谷武史／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>長門健一／国際B級IBOPEN</li>
                    <li>安原さや／レディース</li>
                    <li>富田俊樹／国際A級ＩＡ２</li>
                    <li>小島庸平／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>佐々木 麗／国際B級IBOPEN</li>
                    <li>中野洋子／レディース</li>
                    <li>渡辺祐介／国際A級ＩＡ２</li>
                    <li>山本 鯨／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>佐々木 麗／国際B級IBOPEN</li>
                    <li>竹内優菜／レディース</li>
                    <li>渡辺祐介／国際A級ＩＡ２</li>
                    <li>山本 鯨／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>岸 桐我／国際B級IBOPEN</li>
                    <li>畑尾樹璃／レディース</li>
                    <li>古賀太基／国際A級ＩＡ２</li>
                    <li>成田 亮／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>中島漱也／国際B級IBOPEN</li>
                    <li>本田七海／レディース</li>
                    <li>横山遥希／国際A級ＩＡ２</li>
                    <li>山本 鯨／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>福村 鎌／国際B級IBOPEN</li>
                    <li>川井麻央／レディース</li>
                    <li>横山遥希／国際A級ＩＡ２</li>
                    <li>山本 鯨／国際A級IA1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>山本 鯨／国際A級IA1</li>
                    <li>大城 魁之輔／国際A級IA2</li>
                    <li>鈴木 龍星／国際B級IBOPEN</li>
                    <li>川井 麻央／レディース</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>富田 俊樹／国際A級IA1</li>
                    <li>JAY WILSON／国際A級IA2</li>
                    <li>西岡 蒼志／国際B級IBOPEN</li>
                    <li>久保 まな／レディース</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['60']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>